export default __webpack_public_path__ + "static/media/offer-vertical-chocolate@3x.dbe061f1.png";